import React from "react";
import AllTickets from "../component/sections/ticket/AllTickets";
import AddTicket from "../component/sections/ticket/AddTicket";
import ViewTickets from "../component/sections/ticket/ViewTickets";
import AddCategoryTicket from "../component/sections/ticket/AddCategoryTicket";
import EditCategoryTicket from "../component/sections/ticket/EditCategoryTicket";
import UserTickets from "../component/sections/ticket/UserTickets";
import middleware from "./middlewares/middleware";
import AllCategoryTicket from "../component/sections/ticket/AllCategoryTicket";
import AnswerTicket from "../component/sections/ticket/AnswerTicket";
import AllNotification from "../component/sections/ticket/AllNotificationTicket";
import AddNotification from "../component/sections/ticket/AddNotificationTicket";
import AllNotificationTicket from "../component/sections/ticket/AllNotificationTicket";
import AddNotificationTicket from "../component/sections/ticket/AddNotificationTicket";

const ticketRoutes = [
  {
    path: "/ticket/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTickets />,
        "AllTickets"
      );
    },
    exact: true,
  },
  {
    path: "/ticket/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddTicket />,
        "AddTicket"
      );
    },
    exact: true,
  },
  {
    path: "/ticket/all-ticket-user",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <UserTickets />,
        "UserTickets"
      );
    },

    exact: true,
  },
  {
    path: "/ticket/view/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewTickets />,
        "ViewTickets"
      );
    },
    exact: true,
  },
  {
    path: "/ticket/answer/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AnswerTicket />,
        "AnswerTicket"
      );
    },
    exact: true,
  },
  {
    path: "/ticket/category-ticket",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCategoryTicket />,
        "AllCategoryTicket"
      );
    },
    exact: true,
  },
  {
    path: "/ticket/category-ticket/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddCategoryTicket />,
        "AddCategoryTicket"
      );
    },
    exact: true,
  },
  {
    path: "/ticket/category-ticket/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditCategoryTicket />,
        "EditCategoryTicket"
      );
    },
    exact: true,
  },
  {
    path: "/ticket/all-notification",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllNotificationTicket />,
        "AllNotificationTicket"
      );
    },
    exact: true,
  },
  {
    path: "/ticket/add-notification",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddNotificationTicket />,
        "AddNotificationTicket"
      );
    },
    exact: true,
  },
];

export default ticketRoutes;
